import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

interface ColorBoxProps {
  color: Color
  withBorder?: boolean
}

export const ColorBox = styled.div<ColorBoxProps>`
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  ${({ withBorder }) => withBorder && `border: 1px solid ${Color.Grey300};`}
  background: ${({ color }) => color};
`
